// import { injectReducer } from 'store/reducers'
// import { injectSagas } from 'store/sagas'

export default (store) => ({
  path: 'swap-statements/:cardId',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const SwapStatements = require('./containers/SwapStatementsContainer').default
      // const reducer = require('./modules/reducer').default
      // const sagas = require('./modules/sagas').sagas

      /*  Add the reducer to the store on key 'swapStatements'  */
      // injectReducer(store, { key: 'swapStatements', reducer })
      // injectSagas(store, { key: 'swapStatements', sagas })

      /*  Return getComponent   */
      cb(null, SwapStatements)

    /* Webpack named bundle   */
    }, 'SwapStatements')
  }
})



/** WEBPACK FOOTER **
 ** ./src/routes/Auth/routes/Discovery/routes/MoneyTool/routes/SwapStatements/index.js
 **/